import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";

interface ReimbursementFooterProps {
  isSummary: boolean;
  submitBlockedByDuplicates: boolean;
  disabled: boolean;
  onBack: () => void;
  onNext: () => void;
  onReview: () => void;
  onSubmit: () => void;
}

/**
 * Drawer footer: a back/cancel button plus the step-appropriate primary
 * action (Next on details, Review when duplicates block submit, else Submit).
 */
const ReimbursementFooter: React.FC<ReimbursementFooterProps> = ({
  isSummary,
  submitBlockedByDuplicates,
  disabled,
  onBack,
  onNext,
  onReview,
  onSubmit,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Button variant="primary-outlined" onClick={onBack}>
        {isSummary ? t("Back") : t("Close")}
      </Button>

      {!isSummary ? (
        <Button variant="primary-filled" onClick={onNext}>
          {t("Next")}
        </Button>
      ) : submitBlockedByDuplicates ? (
        <Button variant="primary-filled" disabled={disabled} onClick={onReview}>
          {t("Review")}
        </Button>
      ) : (
        <Button
          variant="primary-filled"
          type="submit"
          disabled={disabled}
          onClick={onSubmit}
        >
          {t("Submit")}
        </Button>
      )}
    </>
  );
};

export default ReimbursementFooter;
